import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Globe, Menu, X } from "lucide-react";

const LOGO_SMALL = "/assets/logo_small.png";

const Header = ({ t, lang, toggleLanguage }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prev => !prev);
  };

  const menuItems = [
    { label: t.nav.menu.rules, path: "/rules" },
    { label: t.nav.menu.community, path: "/community" },
    { label: t.nav.menu.topPlayers, path: "/top-players" },
    { label: t.nav.menu.playerValues, path: "/players-costs" },
    { label: t.nav.menu.download, path: "/download" },
    { label: t.nav.menu.contact, path: "/#contact" }
  ];

  return (
    <>
      {/* Navigation */}
      <nav className="fixed top-0 w-full z-50 px-6 py-6 transition-all duration-300 backdrop-blur-md border-b border-white/5">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button
              onClick={toggleMenu}
              className="text-white/70 hover:text-[#5DFDCB] transition-colors p-2"
              aria-label="Menu"
            >
              {menuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>

            <Link to="/" className="flex items-center gap-3 cursor-pointer group">
              <img src={LOGO_SMALL} alt="FANTEEX" className="h-8 md:h-10 w-auto shrink-0 group-hover:drop-shadow-[0_0_8px_#5DFDCB] transition-all" />
            </Link>
          </div>

          <div className="flex items-center gap-3 md:gap-4">
            <a href="https://app.fanteex.com/signin.html">
              <button className="bg-transparent border border-white/30 text-white px-4 md:px-6 py-2 rounded-full font-display font-bold uppercase text-xs md:text-sm tracking-wider hover:border-[#5DFDCB] hover:text-[#5DFDCB] transition-all duration-300">
                {t.nav.signIn}
              </button>
            </a>
            <a href="https://app.fanteex.com/register.html" className="hidden sm:block">
              <button className="bg-[#5DFDCB] text-black px-4 md:px-6 py-2 rounded-full font-display font-black uppercase text-xs md:text-sm tracking-wider hover:shadow-[0_0_20px_#5DFDCB] transition-all duration-300">
                {t.nav.register}
              </button>
            </a>
          </div>
        </div>
      </nav>

      {/* Slide-out Menu */}
      <AnimatePresence>
        {menuOpen && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={toggleMenu}
              className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40"
            />

            <motion.div
              initial={{ x: "-100%" }}
              animate={{ x: 0 }}
              exit={{ x: "-100%" }}
              transition={{ type: "tween", duration: 0.3 }}
              className="fixed top-0 left-0 h-full w-72 md:w-80 bg-[#0f0518]/95 backdrop-blur-xl border-r border-[#5DFDCB]/20 z-50 flex flex-col"
            >
              <div className="flex items-center justify-between p-6 border-b border-white/10">
                <img src={LOGO_SMALL} alt="FANTEEX" className="h-8 w-auto" />
                <button onClick={toggleMenu} className="text-white/70 hover:text-[#5DFDCB] transition-colors">
                  <X className="w-6 h-6" />
                </button>
              </div>

              <div className="flex-1 py-6">
                {menuItems.map((item, index) => (
                  <Link
                    key={index}
                    to={item.path}
                    onClick={toggleMenu}
                    className="block px-6 py-4 text-white/80 hover:text-[#5DFDCB] hover:bg-white/5 font-display font-bold uppercase tracking-wider text-sm transition-all border-l-2 border-transparent hover:border-[#5DFDCB]"
                  >
                    {item.label}
                  </Link>
                ))}
              </div>

              <div className="p-6 border-t border-white/10">
                <button
                  onClick={toggleLanguage}
                  className="flex items-center gap-2 text-white/70 hover:text-[#5DFDCB] transition-colors font-display font-bold uppercase text-sm tracking-wider"
                >
                  <Globe className="w-4 h-4" />
                  <span>{lang === 'it' ? 'English' : 'Italiano'}</span>
                </button>
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Header;
